<template>
    <div>
        <div class="ajFlex c-page-top">
            <div class="c-page-title">修改个人用户</div>
            <Button type="info" ghost @click="handleBack">返回</Button>
        </div>
        <div class="form-list form-wrapper">
            <Button class="long-addBtn" size="large" long type="dashed" :loading="loading" @click="handleSubmit('formInline')">确认提交</Button>
            <Form class="form-list" ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="150" label-position="right">
                <Row>
                    <Col span="12" offset="4">
                        <FormItem prop="mobile">
                            <div slot="label" style="display: inline-block">
                                <span>手机号码</span>
                                <div style="color: #ff3300">（登录用户名）</div>
                            </div>
                            <Input v-model="formInline.mobile" type="tel"  size="large" placeholder="请输入手机号码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="姓名" prop="name">
                            <Input v-model="formInline.name" size="large" placeholder="请输入姓名"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="身份证号" prop="idCardNumber">
                            <Input v-model="formInline.idCardNumber" type="tel"  size="large" placeholder="请输入身份证号"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    export default {
        components: {

        },
        data(){
            const validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写手机号码!'));
                } else {
                    this.axios({
                        method: 'get',
                        url: '/register/checkMobileExist',
                        params: {
                            mobile:value,
                            id: this.id
                        },
                    }).then( (response) =>{
                        if(response.data){
                            callback(new Error('手机号已经存在!'));
                        }else {
                            callback();
                        }
                    });
                }
            };
            return {
                id:'',
                userType:'',
                loading: false,
                formInline: {
                    mobile: '',
                    name: '',
                    idCardNumber: '',
                },
                ruleInline: {
                    name: [
                        { required: true, type:'string',  message: '姓名不能为空', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, type:'string',  message: '手机号码不能为空', trigger: 'blur' },
                        { pattern: /^1([3456789])\d{9}$/, message: '手机号不正确', trigger: 'change' },
                        { required: true, validator: validatePhone, trigger: 'blur' },
                    ],
                    idCardNumber: [
                        { required: true, type:'string',  message: '身份证号不能为空', trigger: 'blur' }
                    ],
                },
            };
        },
        computed:{
        },
        created(){
            this.id= this.$route.query.id;
            this.userType= this.$route.query.userType;
            this.getPageData();
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            /* 获取页面信息 */
            getPageData(){
                // 获取页面信息
                this.axios({
                    method: 'get',
                    url:'/user/get',
                    params:{
                        id:this.id,
                    }
                }).then((response)=>{
                    if(response.data){
                        this.formInline=response.data;
                    }
                });
            },
            // 返回
            handleBack(){
                this.$router.go(-1);
            },
            // 提交
            handleSubmit(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let data={};
                        Object.assign(data,this.formInline);
                        data.id = this.id;
                        this.loading=true;
                        this.axios({
                            method: 'post',
                            url: '/user/modify',
                            data: data,
                        }).then((response) => {
                            this.loading=false;
                            if(response.data.success){
                                this.$Message.success('提交成功!');
                                this.$router.go(-1);
                            }else {
                                this.$Message.warning(response.data.message);
                            }
                        }).catch( ()=> {
                            this.loading=false;
                        });
                    } else {
                        this.$Message.error('表单验证未通过!');
                    }
                });
            }
        }
    };
</script>
